<template>
    <div class="box">
      <div class="title" v-if="showtitle" @click="toStoreManager(title)">
        <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
          <div class="title-word">{{ title }}</div>
          
          <div style="display: flex;align-items: center; color: #666;" v-if="tip">
            <div class="status-dot" style="background-color: green;"></div><span>正常</span>
            <div class="status-dot" style="background-color: orange; margin-left: 10px;"></div><span>警告</span>
            <div class="status-dot" style="background-color: red; margin-left: 10px;"></div><span>报警</span>
          </div>
        </div>
        
        <div style="display: flex;align-items: center;margin-right:10px;">
          <slot name="selectBox"></slot>
        </div>
        
        <div class="more-btn" v-if="more">
          <span class="more-text">{{ more }}</span>
          <img class="more-icon" src="../assets/image/箭头.png" alt="more" />
        </div>
      </div>
      
      <slot name="othertitle"></slot>
      
      <div class="chart_dec">
        <slot></slot>
      </div>
    </div>
</template>

<script>
export default {
  name: "chartbox",
  props: {
    title: { type: String, default: "标题" },
    more: { type: String, default: "" },
    tip: { type: Boolean, default: false },
    showtitle: { type: Boolean, default: true },
    decPad: { default: true },
  },
  methods: {
    toStoreManager(title) {
      if(title == "每日任务清单详情"){
        this.$router.push({
          path: "/tasksShow",
          query: { from: "aiHeader" },
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-width: 331px;
  max-height: 99%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 8px;
  
  /* --- 1. 完全按照你的要求，保留浅灰色的整体外边框 --- */
  border: 2px solid #FE3B04; 
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  overflow: hidden;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 48px; 
    padding: 0 12px 0 16px;
    
    /* --- 2. 标题栏区域加上微弱的背景色，和下方纯白内容区形成对比 --- */
    background: linear-gradient(90deg, rgba(254, 59, 4, 0.06) 0%, rgba(255, 255, 255, 0) 100%);
    border-bottom: 1px solid #ebeef5; /* 标题栏底部的基础分割线 */

    .title-word {
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 1px;
      color: #333;
      position: relative;
      height: 100%;
      display: flex;
      align-items: center;
    }

    .status-dot {
      width: 12px;
      height: 12px;
      border-radius: 50%;
    }
    .status-dot + span {
      margin-left: 6px;
      font-size: 15px;
      color: #666;
    }

    /* 优化后的“更多”胶囊按钮 */
    .more-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 4px 12px; 
      border-radius: 14px; 
      
      /* 默认状态：白底 + 浅灰边框，融入背景 */
      background-color: #ffffff; 
      border: 1px solid #dcdfe6;
      
      transition: all 0.3s ease;
      white-space: nowrap; 
      flex-shrink: 0; 
      
      .more-text {
        font-size: 12px;
        color: #666; 
        font-weight: 500;
        transition: color 0.3s;
      }

      .more-icon {
        width: 16px; 
        height: auto;
        margin-left: 4px;
        filter: grayscale(100%) opacity(0.6);
        transition: all 0.3s;
      }

      /* 悬浮交互：变为主色调 */
      &:hover {
        border-color: #FE3B04;
        background-color: rgba(254, 59, 4, 0.05); 
        
        .more-text {
          color: #FE3B04; 
        }
        .more-icon {
          /* 用滤镜把图标变成橙色 */
          filter: invert(35%) sepia(96%) saturate(3061%) hue-rotate(345deg) brightness(98%) contrast(106%);
        }
      }
    }
  }
}

.chart_dec {
  flex: 1;
  height: calc(100% - 48px);
  padding: 15px; 
  box-sizing: border-box;
  position: relative;
  background-color: #ffffff; /* 内容区保持纯白 */
}

/* Element UI 相关覆盖 */
::v-deep .el-tree-node__content:hover,
.el-upload-list__item:hover {
  background-color: rgba(254, 59, 4, 0.05);
}
::v-deep .el-tree-node:focus > .el-tree-node__content {
  background-color: rgba(254, 59, 4, 0.08) !important;
  color: #FE3B04 !important;
}
</style>